import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useOnboardingTour } from '@rio-cloud/rio-uikit/useOnboarding';

import { getSteps, RENTAL_ONBOARDING_STEP } from '../features/onboarding/onboardingUtils';
import { useOnboardingTourContext } from '../components/OnboardingTour.context';
import { useShouldShowPartnerBanner } from './useShouldShowPartnerBanner';

export const useOnboarding = () => {
    const intl = useIntl();
    const { setActiveStep } = useOnboardingTourContext();
    const showPartnerOnboardingBanner = useShouldShowPartnerBanner();

    const steps = useMemo(
        () =>
            getSteps(intl, setActiveStep).filter(
                step =>
                    !(
                        !showPartnerOnboardingBanner &&
                        step.element === `[data-onboarding-walkthrough-step="${RENTAL_ONBOARDING_STEP.addPartner}"]`
                    )
            ),
        [intl, showPartnerOnboardingBanner, setActiveStep]
    );

    const onboardingTour = useOnboardingTour({ steps });

    return {
        ...onboardingTour,
        steps,
    };
};
